export default __webpack_public_path__ + "static/media/word.2a98e208.jpg";